import React from "react";

const Contactsubbanner = () => {
  return (
    <>
      <section class="sub_banner position-relative">
        <div class="container position-relative">
          <div class="row">
            <div class="col-12">
              <div class="sub_banner_content text-center" data-aos="fade-up">
                <h1>Contact Us</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contactsubbanner;
